import { DOCS_FORM_NAMES } from "core/consts";
import { FormFieldConfig } from "../..";
import { MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS } from "../Cardiology/sections";
import { DischargeLetterTextarea } from "../DischargeLetterTextarea";

export const DischargeLetterNeurosurgeryFormSections: FormFieldConfig<
  typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_NEUROSURGERY
>["sections"] = [
  {
    fields: {
      additional_diagnostic_findings: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .additionalDiagnosticFindings
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="additional_diagnostic_findings"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 10,
      },
      admission_medications: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .admissionMedication
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="admission_medications"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 12,
      },
      allergies: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames.allergies
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="allergies"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 5,
      },
      anamnesis: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames.anamnesis
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="anamnesis"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 3,
      },
      appointments: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .appointments
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="appointments"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 15,
      },
      clinical_course: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .clinicalCourse
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="clinical_course"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 11,
      },
      diagnoses: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames.diagnoses
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="diagnoses"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 1,
      },
      discharge_medications: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .dischargeMedications
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="discharge_medications"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 13,
      },
      ecg: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={translations.extractDocs.dischargeLetter.formFieldNames.ecg}
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="ecg"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 9,
      },
      lab_results: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames.labResults
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="lab_results"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 8,
      },
      laboratory_parameters: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .laboratoryParameters
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="laboratory_parameters"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 16,
      },
      parameters: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames.parameters
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="parameters"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 7,
      },
      physical_status: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .physicalStatus
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="physical_status"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 6,
      },
      recommendations: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .recommendations
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="recommendations"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 14,
      },
      social_anamnesis: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .socialAnamnesis
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="social_anamnesis"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 4,
      },
      therapy: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames.therapy
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="therapy"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 2,
      },
    },
    position: 1,
    title: ({ translations }) =>
      translations.extractDocs.dischargeLetter.formNeuroSurgery.sectionTitle,
  },
];
